import API from "../API";

export const GetAllProductsApi = async (payload) => {
  try {
    const response = await API.get(`/api/products/all`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetSingleProductsApi = async (payload) => {
  try {
    const response = await API.get(`/api/product/${payload?.productId || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const multipleFileUploadApi = async (payload) => {
  try {
    const formData = new FormData();

    payload.files.forEach((file) => {
      formData.append("files", file); // important
    });
    if (payload?.productId) {
      formData.append("productId", payload?.productId.toString());
    }

    console.log("formData ", formData, payload.files);

    const response = await API.post(`/api/product/upload/files`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteFileApi = async (payload) => {
  try {
    const response = await API.delete(
      `/api/product/file?key=${payload?.key || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
